
import FilterButtonBar from './FilterButtonBar.jsx';

export default FilterButtonBar;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterButtonBar/index.js